const BASE_COLORS = [
  '#E74C3C',
  '#3498DB',
  '#2ECC71',
  '#F39C12',
  '#9B59B6',
  '#1ABC9C',
  '#34495E',
  '#E67E22',
  '#16A085',
  '#8E44AD',
  '#C0392B',
  '#2980B9',
  '#27AE60',
  '#D35400',
  '#7F8C8D',
  '#BDC3C7',
  '#95A5A6',
  '#F1C40F',
  '#FF6B6B',
  '#4ECDC4',
  '#45B7D1',
  '#FFA07A',
  '#98D8C8',
  '#F7DC6F',
  '#BB8FCE',
  '#85C1E2',
  '#F8C471',
  '#82E0AA',
  '#F1948A',
  '#85929E',
];

export function getVehicleColor(index: number): string {
  const baseColorCount = BASE_COLORS.length;

  if (index < baseColorCount) {
    return BASE_COLORS[index];
  }

  const baseIndex = index % baseColorCount;
  const variation = Math.floor(index / baseColorCount);

  const baseColor = BASE_COLORS[baseIndex];
  return adjustColorBrightness(baseColor, variation * 5);
}

function adjustColorBrightness(color: string, percent: number): string {
  const num = parseInt(color.slice(1), 16);
  const r = (num >> 16) & 255;
  const g = (num >> 8) & 255;
  const b = num & 255;

  const adjust = (value: number) => {
    if (percent > 0) {
      return Math.min(255, value + (255 - value) * (percent / 100));
    } else {
      return Math.max(0, value + value * (percent / 100));
    }
  };

  const newR = Math.round(adjust(r));
  const newG = Math.round(adjust(g));
  const newB = Math.round(adjust(b));

  return `#${((1 << 24) + (newR << 16) + (newG << 8) + newB).toString(16).slice(1).toUpperCase()}`;
}

export const TRAIL_DURATION_COLORS = {
  LESS_THAN_1H: '#9B59B6',
  ONE_TO_4H: '#E74C3C',
  FOUR_TO_8H: '#F39C12',
  EIGHT_TO_12H: '#27AE60',
  MORE_THAN_12H: '#3498DB',
};

export function getTrailDurationColor(durationHours: number): string {
  if (durationHours < 1) return TRAIL_DURATION_COLORS.LESS_THAN_1H;
  if (durationHours < 4) return TRAIL_DURATION_COLORS.ONE_TO_4H;
  if (durationHours < 8) return TRAIL_DURATION_COLORS.FOUR_TO_8H;
  if (durationHours < 12) return TRAIL_DURATION_COLORS.EIGHT_TO_12H;
  return TRAIL_DURATION_COLORS.MORE_THAN_12H;
}

export function getTrailPointColor(pointAgeHours: number): string {
  if (pointAgeHours < 1) return TRAIL_DURATION_COLORS.LESS_THAN_1H;
  if (pointAgeHours < 4) return TRAIL_DURATION_COLORS.ONE_TO_4H;
  if (pointAgeHours < 8) return TRAIL_DURATION_COLORS.FOUR_TO_8H;
  if (pointAgeHours < 12) return TRAIL_DURATION_COLORS.EIGHT_TO_12H;
  return TRAIL_DURATION_COLORS.MORE_THAN_12H;
}
